let checkIfExists, readFile, readJson, writeFile, writeJson, makeDir,
  readDir, baseName, sysPath, loc, kill, moveFile, zipToArchive, zip, unzip,
  subscribe, path, resetLoc, jsPath

checkIfExists= readFile= readJson= writeFile= writeJson= makeDir=
  readDir= baseName= sysPath= loc= kill= moveFile= zipToArchive= zip= unzip=
  subscribe= path= resetLoc= jsPath = function(){}

export {checkIfExists, readFile, readJson, writeFile, writeJson, makeDir,
  readDir, baseName, sysPath, loc, kill, moveFile, zipToArchive, zip, unzip,
  subscribe, path, resetLoc, jsPath}
